import type { PaymentGatewayTerminalSaleResult } from '../gateway-terminal-sale.types';
import type { CloverTerminalSaleResponseDetails } from './clover-terminal-sale-response.types';

export const CloverLifecycleFinalizationGatewayOperation = {
    TERMINAL_SALE: 'terminal_sale',
} as const;

export type CloverLifecycleFinalizationGatewayOperation =
    (typeof CloverLifecycleFinalizationGatewayOperation)[keyof typeof CloverLifecycleFinalizationGatewayOperation];

export const CloverLifecycleFinalizationPayloadType = {
    REQUEST: 'clover_lifecycle_finalization_request_v1',
    RESPONSE: 'clover_lifecycle_finalization_response_v1',
} as const;

export type CloverLifecycleFinalizationPayloadType =
    (typeof CloverLifecycleFinalizationPayloadType)[keyof typeof CloverLifecycleFinalizationPayloadType];

export const CloverLifecycleFinalizationOutcome = {
    FINALIZED: 'finalized',
    MALFORMED_RESULT: 'malformed_result',
} as const;

export type CloverLifecycleFinalizationOutcome =
    (typeof CloverLifecycleFinalizationOutcome)[keyof typeof CloverLifecycleFinalizationOutcome];

export interface CloverLifecycleFinalizationRequestDetails {
    readonly gateway_operation: typeof CloverLifecycleFinalizationGatewayOperation.TERMINAL_SALE;
    readonly terminal_sale_response_details: CloverTerminalSaleResponseDetails;
    readonly terminal_sale_result: PaymentGatewayTerminalSaleResult;
}

export interface CloverLifecycleFinalizationNormalizedResult {
    readonly gateway_operation: typeof CloverLifecycleFinalizationGatewayOperation.TERMINAL_SALE;
    readonly status: PaymentGatewayTerminalSaleResult['status'];
    readonly gateway_transaction_id?: string;
    readonly approved_amount?: string;
    readonly authorization_code?: string;
    readonly gateway_token?: string;
    readonly message?: string;
    readonly response_code?: string;
}

export type CloverLifecycleFinalizationResponseDetails =
    | {
          readonly outcome: typeof CloverLifecycleFinalizationOutcome.FINALIZED;
          readonly normalized_result: CloverLifecycleFinalizationNormalizedResult;
      }
    | {
          readonly outcome: typeof CloverLifecycleFinalizationOutcome.MALFORMED_RESULT;
          readonly message: string;
          readonly body: unknown;
      };

export interface CloverLifecycleFinalizationRequestPayload {
    readonly gateway_lifecycle_payload_type: typeof CloverLifecycleFinalizationPayloadType.REQUEST;
    readonly request_details: CloverLifecycleFinalizationRequestDetails;
}

export interface CloverLifecycleFinalizationResponsePayload {
    readonly gateway_lifecycle_payload_type: typeof CloverLifecycleFinalizationPayloadType.RESPONSE;
    readonly response_details: CloverLifecycleFinalizationResponseDetails;
}

export type CloverLifecycleFinalizationPayload =
    | CloverLifecycleFinalizationRequestPayload
    | CloverLifecycleFinalizationResponsePayload;
